Controller = App.loadClass 'core::Angular/Controller'

class exports.DashboardDropdownController extends Controller
    constructor: (@scope) ->
        @open = false
        @show = false
        @scope.$on 'dashboard:close', () =>
            @open = false

    toggle: () ->
        @open = not @open

    close: () ->
        @open = false
        @scope.$broadcast 'dashboard:closed'
